<template>
  <div
    :class="{
      dragging: itemId === draggingId,
      'not-dragging': draggingId !== null && itemId !== draggingId
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    itemId: { type: String, required: true },
    draggingId: { type: String, default: null }
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable-next-line selector-pseudo-element-no-unknown */
.dragging ::v-deep div {
  background-color: var(--v-lightTwo-base) !important;
}

.dragging,
.not-dragging,
.dragging:active,
.not-dragging:active {
  cursor: grabbing !important;
}

/* stylelint-disable-next-line selector-pseudo-element-no-unknown */
.not-dragging ::v-deep div {
  background-color: inherit !important;
}
</style>
